module.exports = __webpack_public_path__ + "static/media/RCImg6.3dbe7c64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RCImg6.jpg
// module id = 1167
// module chunks = 0